import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import KpiTargetTableHeader from './KpiTargetTableHeader';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { search } from 'services/salesperson-kpi/kpiTargetService';
import PageHeader from 'components/common/PageHeader';
import KpiTargetTable from './KpiTargetTable';
import KpiTargetModal from './KpiTargetModal';
import { usePaginationBe } from 'hooks/useBeHandle';
import PropTypes from 'prop-types';
import KpiTargetFilter from './KpiTargetFilter';
import { joinDataMultiDropdown } from 'helpers/dropdownFuncHelper';

const KpiTargetDashboard = ({ isFromManagerPage = false }) => {
  const defaultRQ = { ...new BaseTableRQ(1, 12), isFromManagerPage };
  const [sections, setKpiTargets] = useState([]);
  const [total, setTotal] = useState(0);
  const [paging, setPaging] = useState({ ...defaultRQ });
  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState({});
  const [isFilter, setIsFilter] = useState(false);
  const [filter, setFilter] = useState({});

  const toggelFilter = () => {
    setIsFilter(!isFilter);
  };
  const addNew = () => {
    setIsModal(true);
    setDataModal(null);
  };

  const handleCloseModal = () => {
    setIsModal(false);
    setDataModal(null);
  };
  const handleSubmitModal = () => {
    handleCloseModal();
    loadKpiTargets(defaultRQ);
  };

  useEffect(() => {
    loadKpiTargets(defaultRQ);
  }, []);

  const loadKpiTargets = pagingRq => {
    search(pagingRq)
      .then(res => {
        if (res) {
          setKpiTargets(res.items);
          setTotal(res.total);
        }
      })
      .catch(err => {
        console.log(err);
      });
    setPaging(pagingRq);
  };

  const handleSeach = keyword => {
    loadKpiTargets({ ...defaultRQ, keyword });
  };

  const { gotoPage, nextPage, previousPage } = usePaginationBe(
    paging,
    total,
    loadKpiTargets
  );

  const handleChange = (field, value) => {
    console.log(field, value);
    setFilter({
      ...filter,
      [field]: value
    });
  };

  const handleFilterSubmit = () => {
    let rq = mapRQData(filter);
    loadKpiTargets({ ...defaultRQ, ...rq });
  };

  const mapRQData = data => {
    if (data) {
      let mapRq = { ...data };
      if (data?.date && data?.date instanceof Date) {
        mapRq.targetDate = data.date.toLocaleDateString('en-CA') //data?.date?.toISOString();
      }
      console.log(data);
      mapRq.saleIds = joinDataMultiDropdown(data?.sale);
      return mapRq;
    }
    return null;
  };

  return (
    <>
      <PageHeader
        title="Kpi Targets"
        description={`Manage and view all available KpiTarget from this page.`}
        className="mb-3"
      ></PageHeader>
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card>
            <Row style={{ padding: '10px' }}>
              <KpiTargetTableHeader
                toggelFilter={() => toggelFilter()}
                toggelModal={() => addNew()}
                handleSearch={handleSeach}
                isFromManagerPage={isFromManagerPage}
                style={{ padding: '10px' }}
              />
              {isFilter && (
                <Col
                  lg={12}
                  style={{
                    padding: '17px',
                    paddingTop: '8px',
                    paddingBottom: '8px'
                  }}
                >
                  <KpiTargetFilter
                    displayOption={{
                      showHeader: true,
                      showFooter: true,
                      col: '6'
                    }}
                    style={{
                      paddingBottom: '10px',
                      maxHeight: '250px',
                      overflowY: 'auto'
                    }}
                    handleChange={handleChange}
                    formData={filter}
                    handleSubmit={handleFilterSubmit}
                    isFromManagerPage={isFromManagerPage}
                  />
                </Col>
              )}
              <KpiTargetTable
                data={sections}
                paging={paging}
                total={total}
                nextPage={nextPage}
                previousPage={previousPage}
                gotoPage={gotoPage}
                handleClickRow={(e, row) => {
                  if (row) {
                    setDataModal(row.original);
                    setIsModal(true);
                  }
                }}
                isFromManagerPage={isFromManagerPage}
              />
            </Row>
          </Card>
        </Col>
      </Row>
      <KpiTargetModal
        isShow={isModal}
        handleClose={handleCloseModal}
        data={dataModal}
        handleSubmit={handleSubmitModal}
      />
    </>
  );
};

KpiTargetDashboard.propTypes = { isFromManagerPage: PropTypes.bool };

export default KpiTargetDashboard;
